// Seasonal designs as Announcement layouts. Each is a layout id,
// `season:<season id>:<number>`, so the studio, the text fields, formats,
// sharing and campaigns treat it like any other layout; data/postTypes.js
// finds it through `layoutOf`. They aren't in the job's own list of layouts,
// so Social's rotation and the design pickers only show a season's when
// they're asked for it.
import { SEASONS } from './catalogue'
import { momentsBetween } from '../data/seasonal'

const PREFIX = 'season:'
const byId = {}
SEASONS.forEach((s) => { byId[s.id] = s })

export const seasonalId = (seasonId, i) => `${PREFIX}${seasonId}:${i + 1}`
export const isSeasonal = layout => typeof layout === 'string' && layout.indexOf(PREFIX) === 0

// The season and design a layout id names, or null
export const seasonalOf = (layout) => {
  if (!isSeasonal(layout)) return null
  const [, id, n] = layout.split(':')
  const season = byId[id]
  const design = season && season.designs[Number(n) - 1]
  return design ? { season, design, index: Number(n) - 1 } : null
}

// Seasons with designs, and a season's layouts in order
export const SEASONAL = SEASONS.map(({ id, name }) => ({ id, name }))
export const hasSeasonal = seasonId => !!byId[seasonId]
// Seasons with designs, the one on now or coming next first
export const seasonsFrom = (now = new Date()) => {
  const next = momentsBetween(now, new Date(now.getFullYear() + 1, now.getMonth(), now.getDate())).map(m => m.id).filter(id => byId[id])
  const order = next.filter((id, i) => next.indexOf(id) === i)
  return [...order, ...SEASONAL.map(x => x.id).filter(id => !order.includes(id))].map(id => SEASONAL.find(x => x.id === id))
}
export const seasonalLayouts = seasonId => (byId[seasonId] ? byId[seasonId].designs.map((d, i) => seasonalId(seasonId, i)) : [])

// The layout as data/postTypes.js describes layouts
export const seasonalLayout = (layout) => {
  const found = seasonalOf(layout)
  if (!found) return null
  const { season, design } = found
  return {
    name: design.headline,
    blurb: `${season.name}, ${design.purpose.toLowerCase()}`,
    theme: 'paper',
    seasonal: true,
    offer: !!design.offer,
    purpose: design.purpose,
    content: () => ({ eyebrow: season.name, headline: design.headline, body: design.body, cta: design.cta }),
  }
}

// `{salon}` in a design's words, as the salon's name
export const withSalon = (content, salon) => {
  const out = {}
  Object.keys(content || {}).forEach((k) => { out[k] = typeof content[k] === 'string' ? content[k].replace(/\{salon\}/g, salon || 'us') : content[k] })
  return out
}

// A campaign's jobs and the designs that do them, best first
const FOR_ROLE = {
  open: ['Launch', 'Spotlight', 'Inspiration'],
  lastcall: ['Booking reminder', 'Booking', 'Follow-up'],
  close: ['Community', 'Follow-up'],
}
// The season's next design for a campaign job that isn't in `used`
// (layout ids), or null. Offer designs need the salon's own offer.
export const seasonalFor = (seasonId, role, used = new Set()) => {
  const season = byId[seasonId]
  if (!season) return null
  const free = season.designs.map((d, i) => ({ d, id: seasonalId(seasonId, i) })).filter(x => !x.d.offer && !used.has(x.id))
  const wanted = FOR_ROLE[role] || []
  const best = wanted.map(p => free.find(x => x.d.purpose === p)).find(Boolean) || free[0]
  return best ? best.id : null
}
